import { Validation } from './Validation';
import CustomerJson, { defaultCustomerJson, validateBirthdayBookingCustomerJson, validateHolidayProgramBookingCustomerJson, validateHolidayProgramBookingCustomerJsonAddNew } from "./CustomerJson";
import { HolidayProgramBookingStatus } from "./HolidayProgramBookingStatus";
import SepaMandateJson, { validateSepaMandate, validateSepaMandateAddNew } from "./SepaMandateJson";
import InvoiceInfoJson from "./InvoiceInfoJson";

export default interface HolidayProgramBookingJson {
   ID: number | null,

   /**
    * Titel des Ermäßigungspreises oder null falls der Basispreis gezahlt wurde.
    */
   selectedDiscount: string | null,

   /**
    * Details wie Personalnummer etc. die für den Ermäßigungspreis notwendig sind.
    */
   selectedDiscountInfo: string | null,

   /**
    * Titel der Extras die gebucht wurden.
    */
   selectedExtras: string[];

   /**
    * Kunden für die gebucht wurde.
    */
   customers: CustomerJson[];

   /**
    * Teilnehmende dürfen alleine kommen
    */
   allowedToComeAlone: boolean;

   /**
    * Teilnehmende dürfen alleine gehen
    */
   allowedToGoAlone: boolean;

   /**
    * Name einer zur Abholung berechtigten Person
    */
   authorizedToCollect: string;

   /**
    * Freitextfeld für Alternativtermine etc.
    */
   remarks: string;

   /**
    * Status der Buchung.
    */
   state: HolidayProgramBookingStatus;

   /**
    * Preis der Buchung für alle Kinder zusammen in Eurocent.
    */
   price: number | null;

   /**
    * Kosten in Eurocent wenn der Geburtstag storniert wird.
    */
   cancellationFee: number;

   /**
    * Stornierungsbedingungen.
    */
   cancellationRemarks: string;

   /**
    * Datum und Uhrzeit zu der gebucht wurde.
    */
   bookingDateTime: string;

   /**
    * Gibt an ob es sich um eine alleinerziehenden Elternteil handelt.
    */
   isSingleParent: boolean | null;

   /**
    * Gibt an ob der Elternteil arbeitet.
    */
   isWorking: boolean;

   /**
    * Gibt an ob der Partner (sofern vorhanden) vom Elternteil arbeitet.
    */
   isPartnerWorking: boolean;

   /**
    * Gibt an ob das Elternteil verheiratet ist. Wird nicht mehr genutzt -> isSingleParent true, false | null
    */
   isMarried: boolean;

   /**
    * Arbeitgeber des ersten Elternteils (falls für Preiskategorie benötigt).
    */
   employerFirst: string,

   /**
    * Arbeitgeber des zweiten Elternteils (falls für Preiskategorie benötigt).
    */
   employerSecond: string,

   /**
    * SEPA-Lastschriftmandat für die Zahlung. Kann auch null sein, wenn eine Bar oder Rechnungszahlung gewünscht ist.
    */
   sepaMandate: SepaMandateJson | null;

   /**
     * Rechnungsinformationen wie Rechnungsnummer.
     */
   invoiceInfos: InvoiceInfoJson[] | null;
}

export function defaultHolidayProgramBookingJson(): HolidayProgramBookingJson {
   return {
      ID: null,
      selectedDiscount: null,
      selectedDiscountInfo: "",
      selectedExtras: [],
      customers: [{ ...defaultCustomerJson() }],
      allowedToComeAlone: false,
      allowedToGoAlone: false,
      authorizedToCollect: "",
      remarks: "",
      state: HolidayProgramBookingStatus.pending,
      price: null,
      cancellationFee: 0,
      cancellationRemarks: "",
      bookingDateTime: new Date().toISOString(),
      isSingleParent: null,
      isWorking: false,
      isPartnerWorking: false,
      isMarried: false,
      employerFirst: "",
      employerSecond: "",
      sepaMandate: null,
      invoiceInfos: null,
    };
}

export function validateHolidayProgramBookingJson(item: HolidayProgramBookingJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, false)
      .validateString("authorizedToCollect", 250)
      .validateString("remarks", 500)
      .validateAllUsingFunction("customers", validateHolidayProgramBookingCustomerJson, 1)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateInteger("price", 0, null, false)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .validateString("employerFirst", 200)
      .validateString("employerSecond", 200)
      .finish();
}
export function validateHolidayProgramBookingJsonAddNew(item: HolidayProgramBookingJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("authorizedToCollect", 250)
      .validateString("remarks", 500)
      .validateAllUsingFunction("customers", validateHolidayProgramBookingCustomerJson, 1)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateInteger("price", 0, null, true)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .validateString("employerFirst", 200)
      .validateString("employerSecond", 200)
      .finish();
}
export function validateHolidayProgramBookingJsonBookingForm(item: HolidayProgramBookingJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("authorizedToCollect", 250)
      .validateString("remarks", 500)
      .validateEquals("state", HolidayProgramBookingStatus.pending)
      .validateAllUsingFunction("customers", validateHolidayProgramBookingCustomerJsonAddNew, 1)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandateAddNew, true)
      .validateInteger("price", 0, null, true)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .validateString("employerFirst", 200)
      .validateString("employerSecond", 200)
      .finish();
}